import httpClient from '~/lib/http-client';

/** Client-safe integration state from studio — never includes secrets. */
export interface IntegrationState {
  integrationId: string;
  enabled: boolean;
  credentialMode: string;
  hasCustomCredentials: boolean;
}

/** All enabled/configured integrations for a deployment. */
export async function apiGetIntegrations(deploymentId: string): Promise<IntegrationState[]> {
  try {
    const { data } = await httpClient.get<IntegrationState[]>(`/api/deployments/static/${deploymentId}/integrations`);
    return data;
  } catch {
    return [];
  }
}

/**
 * Enable an integration and/or save BYO credentials. Passing `config` stores the
 * owner's own credentials (encrypted server-side) and switches to BYO mode.
 */
export async function apiSaveIntegrationConfig(
  deploymentId: string,
  integrationId: string,
  body: { enabled?: boolean; config?: Record<string, string> },
): Promise<IntegrationState> {
  const { data } = await httpClient.post<IntegrationState>(
    `/api/deployments/static/${deploymentId}/integrations/${integrationId}`,
    body,
  );
  return data;
}
